export default "__VITE_ASSET__DPjSjCgi__"